(function () {
  "use strict";
  var SHOP = "https://velorahealthy.store";
  window.__BRAND__ = {
    name: "VELORA",
    tagline: "Built to perform",
    shop: SHOP,
    checkout: {
      "breath-device":        SHOP + "/products/breath-device",
      "multi-mancuernas":     SHOP + "/products/multi-mancuernas",
      "banco-multifuncional": SHOP + "/products/banco-multifuncional",
      "esterilla":            SHOP + "/products/esterilla-antideslizante",
      "core-starter":     SHOP + "/cart/47552082706603:1,47552963838123:1",
      "performance-kit":  SHOP + "/cart/47552082706603:1,47552965345451:1,47552963838123:1",
      "elite-complete":   SHOP + "/cart/47552082706603:1,47552965345451:1,47552963838123:1,47552968196267:1"
    },
    contact: { email: "supportvelorahealthy@gmail.com" }
  };
})();
